export class Conference {
    id: number;
    number: string;
    name: string;
    type: string;
    pin: string;
}
